module.exports = __webpack_public_path__ + "static/media/line1.ea543bf5.png";